import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import { BrowserRouter } from "react-router-dom";
import { ThemeProvider, createTheme } from "@mui/material/styles";
import StyledEngineProvider from "@mui/styled-engine/StyledEngineProvider";
import "./app.css";
import store from "./store";
import { Provider } from "react-redux";

const theme = createTheme({
  components: {
    MuiTypography: {
      defaultProps: {
        component: "p",
      },
    },
  },

  typography: {

    thinmedium: {
      // fontSize: "36px",
      fontSize: "50px",
      fontWeight: 300,
      fontFamily: "Helvetica-Neue",
      lineHeight: 1.2,
      '@media screen and (max-width: 450px)': {
        fontSize: '25px'
      },
    },
    thinmedium3: {
      fontSize: '32px',
      fontWeight: 300,
      fontFamily: 'Helvetica-Neue',
      lineHeight: 1.16,
      '@media screen and (max-width: 450px)': {
        fontSize: '20px'
      },
    },
    thinmedium2: {
      fontSize: "32px",
      fontWeight: 300,
      fontFamily: "Helvetica-Neue",
      lineHeight: 1.16,
      '@media screen and (max-width: 450px)': {
        fontSize: '20px'
      },
    },
    thickmedium: {
      fontSize: "32px",
      fontWeight: 700,
      fontFamily: "Helvetica-Neue",
      lineHeight: 1.2,
      '@media screen and (max-width: 450px)': {
        fontSize: '30px'
      },
    },
    thinmediumhelve: {
      // fontSize: "36px",
      fontSize: "32px",
      fontWeight: 300,
      fontFamily: "Helvetica",
      lineHeight: 1.2,
    },
    thickmediumhelve: {
      fontSize: "32px",
      fontWeight: 700,
      fontFamily: "Helvetica",
      lineHeight: 1.2,
    },
    thinlarge: {
      fontSize: "50px",
      fontWeight: 300,
      fontFamily: "Helvetica-Neue",
      lineHeight: 1.16,
      '@media screen and (max-width: 450px)': {
        fontSize: '20px'
      },
    },
    thicklarge: {
      // fontSize: "52px",
      fontSize: "50px",
      fontWeight: 300,
      fontFamily: "Helvetica-Neue",
      lineHeight: 1.2,
      '@media screen and (max-width: 450px)': {
        fontSize: '30px'
      },
    },
    thinlargehelve: {
      fontSize: "50px",
      fontWeight: 300,
      fontFamily: "Helvetica",
      lineHeight: 1.16,
    },
    thicklargehelve: {
      fontSize: "50px",
      fontWeight: 700,
      fontFamily: "Helvetica",
      lineHeight: 1.16,
    },
    thinsmall: {
      // fontSize: "20px",
      fontSize: "16px",
      lineHeight: 1.3,
      fontFamily: "Helvetica-Neue",
      fontWeight: 300,
    },
    thicksmall: {
      // fontSize: "20px",
      fontSize: "16px",
      lineHeight: 1.3,
      fontFamily: "Helvetica-Neue",
      fontWeight: 700,
    },
  },
  palette: {
    customBlue: "#46bacf",
    customGreen: "#28ac50",
    customRed: "#e35030",
    customYellow: "#eaae2d",
    customnewBlue: "#007f6b",
    customnewGreen: "#28ac50",
  },
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <StyledEngineProvider injectFirst>
    <Provider store={store}>
      <BrowserRouter 
        basename={"/"}>
        <ThemeProvider theme={theme}>
          <App />
        </ThemeProvider>
      </BrowserRouter>
    </Provider>
  </StyledEngineProvider>
);
